import { render, staticRenderFns } from "./RangeSlider.vue?vue&type=template&id=459f787f&"
import script from "./RangeSlider.vue?vue&type=script&lang=js&"
export * from "./RangeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\07.00\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459f787f')) {
      api.createRecord('459f787f', component.options)
    } else {
      api.reload('459f787f', component.options)
    }
    module.hot.accept("./RangeSlider.vue?vue&type=template&id=459f787f&", function () {
      api.rerender('459f787f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Wes/RangeSlider.vue"
export default component.exports